/**
 * Mobile Login Page for Rider Gateway
 * Main authentication entry point for mobile users
 */

import type { FC } from 'react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../hooks/reduxHooks';
import { selectIsAuthenticated, selectIsInitialized } from '../store/slices/authSlice';
import MobileAuthLayout from '../components/templates/MobileAuthLayout';
import MobileLoginForm from '../components/organisms/MobileLoginForm';

const LoginPage: FC = () => {
  const navigate = useNavigate();
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const isInitialized = useAppSelector(selectIsInitialized);

  // Redirect to dashboard if already authenticated
  useEffect(() => {
    if (isInitialized && isAuthenticated) {
      navigate('/dashboard', { replace: true });
    }
  }, [isAuthenticated, isInitialized, navigate]);

  // Show loading until auth is initialized
  if (!isInitialized) {
    return (
      <MobileAuthLayout>
        <MobileLoginForm
          title="Checking your session"
          subtitle="Hang tight — we're verifying your authentication status."
        />
      </MobileAuthLayout>
    );
  }

  return (
    <MobileAuthLayout>
      <MobileLoginForm />
    </MobileAuthLayout>
  );
};

export default LoginPage;